<template>
  <div class="dataView flex" v-loading="loading">
    <div style="width: 1%; height: 100%">
      <div
        class="lineStyle_1"
        style="
          position: absolute;
          left: -19.3%;
          transform: rotateY(180deg) rotate(270deg);
          top: 53%;
          z-index: 9999;
          width: 40%;
        "
      >
        <div class="lineStyle_2"></div>
        <div class="lineStyle_3"></div>
      </div>
    </div>
    <div style="width: 100%; height: 100%">
      <!--header-->
      <div class="header flex">
        <div
          style="
            color: white;
            font-weight: 900;
            font-size: 20px;
            margin-left: 40px;
            font-style: oblique;
            padding-left: 20px;
          "
        >
          {{ $store.state.adminSetting.adst02 || "BIM协同管理云平台" }}大数据
        </div>
        <div class="lineStyle_1" style="width: 72%">
          <div class="lineStyle_2"></div>
          <div class="lineStyle_3"></div>
        </div>

        <!-- {{ $store.state.adminSetting.adst02 || "BIM协同管理云平台" }}大数据 -->
      </div>

      <!--main-->
      <div class="data_content">
        <div class="data_main">
          <div class="data_main_top flex">
            <div
              class="main_top1 flex_center"
              :class="{ active: currentTop === 1 }"
              @click="handle(1)"
            >
              <div class="mainbg1">
                <div class="fontS28" v-show="viewData.MapsList">
                  <!-- {{ sum(viewData.MapsList, "companysum") }} -->
                  {{ viewData.trueData.companySum }}
                </div>
                <div class="colorGray">企业总数</div>
              </div>
            </div>
            <div
              class="main_top1 flex_center"
              :class="{ active: currentTop === 2 }"
              @click="handle(2)"
            >
              <div class="mainbg1 mainbg2">
                <div class="fontS28" v-show="viewData.MapsList">
                  <!-- {{ sum(viewData.MapsList, "projectsum") }} -->
                  {{ viewData.trueData.projectSum }}
                </div>
                <div class="colorGray">项目总数</div>
              </div>
            </div>
            <div
              class="main_top1 flex_center"
              :class="{ active: currentTop === 3 }"
              @click="handle(3)"
            >
              <div class="mainbg1 mainbg3">
                <div class="fontS28" v-show="viewData.MapsList">
                  <!-- {{ sum(viewData.MapsList, "usersum") }} -->
                  {{ viewData.trueData.userSum }}
                </div>
                <div class="colorGray">用户总数</div>
              </div>
            </div>
            <div
              class="main_top1 flex_center"
              :class="{ active: currentTop === 5 }"
              @click="handle(5)"
            >
              <div class="mainbg1 mainbg4">
                <div class="fontS28" v-show="viewData.MapsList">
                  <!-- {{ sum(viewData.MapsList, "modelsum") }} -->
                  {{ viewData.trueData.modelSum }}
                </div>
                <div class="colorGray">模型总数</div>
              </div>
            </div>
            <div
              class="main_top1 flex_center"
              :class="{ active: currentTop === 4 }"
              @click="handle(4)"
            >
              <div class="mainbg1 mainbg5" v-show="viewData.MapsList">
                <div class="fontS28">
                  <!-- {{ sum(viewData.MapsList, "modelsizesum").toFixed(1) }} -->
                  {{ viewData.trueData.modelSize }}GB
                </div>
                <div class="colorGray">模型容量</div>
              </div>
            </div>
          </div>
          <div class="main_left fl">
            <div class="left_1 t_btn6">
              <!--左上边框-->
              <!-- <div class="t_line_box">
              <i class="t_l_line"></i>
              <i class="l_t_line"></i>
            </div> -->
              <!--右上边框-->
              <!-- <div class="t_line_box">
              <i class="t_r_line"></i>
              <i class="r_t_line"></i>
            </div> -->
              <!--左下边框-->
              <!-- <div class="t_line_box">
              <i class="l_b_line"></i>
              <i class="b_l_line"></i>
            </div> -->
              <!--右下边框-->
              <!-- <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div> -->
              <div class="main_title1">男女占比</div>
              <div
                class="flex"
                style="justify-content: space-around; margin-top: 40px"
              >
                <div class="flex">
                  <img
                    src="../../assets/admin/dataImg/Group 937.png"
                    width="60"
                    alt=""
                  />
                  <div style="color: white; margin-left: 10px">
                    <p>男</p>
                    <p style="color: #03bed6">
                      {{ manCount.toFixed(2) * 100 }}%
                    </p>
                  </div>
                </div>
                <div class="flex">
                  <img
                    src="../../assets/admin/dataImg/Group 936.png"
                    width="60"
                    alt=""
                  />
                  <div style="color: white; margin-left: 10px">
                    <p>女</p>
                    <p style="color: #03bed6">
                      {{ girlCount.toFixed(2) * 100 }}%
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div id="sexAndAge" class="width-he100"></div> -->
            </div>
            <div class="left_2">
              <div class="main_title1">年龄占比</div>
              <div class="width-he100 flex" style="height: 90%">
                <div id="xueli" class="width-he100"></div>
                <div
                  class="width-he100 flex_center"
                  style="
                    width: 50%;
                    color: #fff;
                    justify-content: space-between;
                    margin-right: 5%;
                  "
                >
                  <div
                    class="xueName flex"
                    style="justify-content: space-around"
                    v-for="(item, index) in ageProportion"
                    :key="index"
                  >
                    <div>{{ item.name }}</div>
                    <div>{{ item.value }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="left_2">
              <div class="main_title1" style="padding-left: 11%">
                <img alt />
                登录人数统计
              </div>
              <div id="loginNum" class="width-he100"></div>
            </div>
          </div>
          <div class="main_center fl">
            <div class="center_text">
              <!-- <div class="t_line_box">
              <i class="r_b_line"></i>
              <i class="b_r_line"></i>
            </div> -->
              <!-- <div class="main_title">{{ name }}</div> -->
              <div id="mapChina" class="width-he100" style="height: 100%"></div>
            </div>
          </div>
          <div class="main_right fr">
            <div class="right_1">
              <div class="main_title1" style="padding-left: 11%">
                企业类别情况
              </div>
              <div id="enterpriseAnalogy" class="width-he100"></div>
            </div>
            <div class="right_2">
              <div class="main_title1" style="padding-left: 11%">
                业务数据统计
              </div>
              <div id="DataList" class="width-he100"></div>
            </div>
            <div class="right_2">
              <div class="main_title1" style="padding-left: 11%">
                模型上传总量
              </div>
              <div id="ModelSumList" class="width-he100"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetBigData } from "@/setAxios";
import "@/assets/three.min.js";
export default {
  data() {
    return {
      viewData: {
        MapsList: [],
        trueData: {
          companySum: null,
          projectSum: null,
          userSum: null,
          modelSum: null,
          modelSize: null,
        },
      },
      arr: null,
      loading: false,
      tarGetId: 1,
      obj: [],
      name: "企业总数",
      sumValue: 0,
      currentTop: 1,
      manCount: 1,
      girlCount: 1,
      ageProportion: [],
    };
  },
  computed: {
    sum: () => {
      return (item, name) => {
        return item.reduce((a, b) => {
          return (a += b[name]);
        }, 0);
      };
    },
  },
  created() {
    this.loading = true;
  },
  async mounted() {
    let res = await GetBigData();
    this.viewData = res.Data;
    this.loading = false;
    var count =
      this.viewData.UserSexList[0].sum + this.viewData.UserSexList[1].sum;
    this.manCount = this.viewData.UserSexList[0].sum / count;
    this.girlCount = this.viewData.UserSexList[1].sum / count;
    this.initMap();
    // this.sexAndAgeInit();
    this.xueliInit();
    this.loginNum();
    this.enterpriseAnalogy();
    this.DataList();
    this.ModelSumList();
  },
  methods: {
    handle(index) {
      this.currentTop = index;
      this.changeData(index);
    },
    changeData(data) {
      this.tarGetId = data;
      let _this = this;
      _this.obj = [];
      switch (this.tarGetId) {
        case 1:
          this.viewData.MapsList.forEach((ele) => {
            ele.name = ele.area;
            ele.value = ele.companysum;
            _this.obj.push(ele);
          });
          _this.name = "企业总数";
          _this.initMap(_this.obj, 1);
          break;
        case 2:
          this.viewData.MapsList.forEach((ele) => {
            ele.name = ele.area;
            ele.value = ele.projectsum;
            _this.obj.push(ele);
          });
          _this.name = "项目总数";
          _this.initMap(_this.obj, 2);
          break;
        case 3:
          this.viewData.MapsList.forEach((ele) => {
            ele.name = ele.area;
            ele.value = ele.usersum;
            _this.obj.push(ele);
          });
          _this.name = "用户总数";
          _this.initMap(_this.obj, 3);
          break;
        case 4:
          this.viewData.MapsList.forEach((ele) => {
            ele.name = ele.area;
            ele.value = ele.modelsizesum;
            _this.obj.push(ele);
          });
          _this.name = "模型总量";
          _this.initMap(_this.obj, 4);
          break;
        case 5:
          this.viewData.MapsList.forEach((ele) => {
            ele.name = ele.area;
            ele.value = ele.modelsum;
            _this.obj.push(ele);
          });
          _this.name = "模型个数";
          _this.initMap(_this.obj, 5);
          break;
        default:
          this.obj = [];
      }
    },
    initMap(data, type) {
      let dataList = [];
      if (data) {
        data.forEach((ele) => {
          dataList.push({ name: ele.name, value: ele.value });
        });
      } else {
        this.viewData.MapsList.forEach((ele) => {
          ele.name = ele.area;
          ele.value = ele.companysum;
          dataList.push({ name: ele.name, value: ele.value });
        });
      }
      var mapChina = this.$echarts.init(
        document.getElementById("mapChina"),
        "macarons2"
      );
      let option = {
        tooltip: {
          formatter: function (params, ticket, callback) {
            if (type) {
              switch (type) {
                case 1:
                  var str = `企业总数：<br />${params.name}：${params.value}个`;
                  return str;
                  break;
                case 2:
                  var str = `项目总数：<br />${params.name}：${params.value}个`;
                  return str;
                  break;
                case 3:
                  var str = `用户总数：<br />${params.name}：${params.value}个`;
                  return str;
                  break;
                case 4:
                  var str = `模型总量：<br />${params.name}：${params.value}G`;
                  return str;
                  break;

                case 5:
                  var str = `模型个数<br />${params.name}：${params.value}个`;
                  return str;
                  break;
                default:
                  return (
                    params.seriesName +
                    "<br />" +
                    params.name +
                    "：" +
                    params.value
                  );
              }
            } else {
              return `企业总数：<br />${params.name}：${params.value}个`;
            }
          },
        },
        dataRange: {
          x: "20%",
          y: "80%",
          textStyle: {
            color: "white",
          },
          splitList: [
            { start: 70, color: "#454ad6" },
            { start: 50, end: 70, color: "#5462d8" },
            { start: 30, end: 50, color: "#6883db" },
            { start: 10, end: 30, color: "#81acde" },
            { start: 0, end: 10, color: "#afeae7" },
            { start: 0, end: 0, color: "#fff" },
          ],
        },
        geo: {
          map: "china",
          roam: false,
          zoom: 1.23,
          label: {
            normal: {
              show: true,
              fontSize: "10",
              color: "rgba(0,0,0,0.7)",
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(147, 235, 248, 1)",
              borderWidth: 1,
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(147, 235, 248, 0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(147, 235, 248, .2)", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              shadowColor: "rgba(128, 217, 248, 1)",
              // shadowColor: 'rgba(255, 255, 255, 1)',
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10,
            },
            emphasis: {
              areaColor: "#389BB7",
              borderWidth: 0,
            },
          },
        },
        series: [
          {
            name: "信息量",
            type: "map",
            label: {
              normal: {
                show: true, //显示省份标签
                textStyle: {
                  color: "#fbfdfe",
                }, //省份标签字体颜色
              },
              emphasis: {
                //对应的鼠标悬浮效果
                show: true,
                textStyle: {
                  color: "#323232",
                },
              },
            },
            geoIndex: 0,
            data: dataList,
          },
        ],
      };
      mapChina.setOption(option);
      window.addEventListener("resize", () => {
        mapChina.resize();
      });
    },
    // 性比和年龄

    sexAndAgeInit() {
      let _this = this;
      var sexAndAge = this.$echarts.init(
        document.getElementById("sexAndAge"),
        "macarons"
      );
      // let data = _this.viewData.UserAgeList;
      // let arrName = this.getArrayValue(data, "age");
      // let arrValue = this.getArrayValue(data, "sum");
      // this.sumValue = eval(arrValue.join("+"));
      // let objData = this.array2obj(data, "age");
      // let optionData = this.getData(data);
      // console.log(
      //   arrName,
      //   arrValue,
      //   this.sumValue,
      //   objData,
      //   optionData,
      //   "----"
      // );
      // let option = {
      //   backgroundColor: "#000",
      //   title: {
      //     text: "年龄占比",
      //     textStyle: {
      //       color: "#fff",
      //     },
      //     left: "27%",
      //     bottom: "42%",
      //   },
      //   legend: {
      //     show: true,
      //     icon: "circle",
      //     top: "center",
      //     left: "70%",
      //     data: arrName,
      //     width: 50,
      //     padding: [0, 5],
      //     itemGap: 25,
      //     formatter: function (name) {
      //       return (
      //         "{title|" + name + "}&ndsp;{value|" + objData[name].value + "}  "
      //       );
      //     },

      //     textStyle: {
      //       rich: {
      //         title: {
      //           fontSize: 16,
      //           lineHeight: 15,
      //           color: "rgb(0, 178, 246)",
      //         },
      //         value: {
      //           fontSize: 18,
      //           lineHeight: 20,
      //           color: "#fff",
      //         },
      //       },
      //     },
      //   },
      //   tooltip: {
      //     show: true,
      //     trigger: "item",
      //     formatter: "{a}<br>{b}:{c}({d}%)",
      //   },
      //   color: [
      //     "rgb(16,113,245)",
      //     "rgb(6,192,115)",
      //     "rgb(41,182,234)",
      //     "rgb(9,124,156)",
      //   ],
      //   grid: {
      //     top: "16%",
      //     bottom: "53%",
      //     left: "30%",
      //     containLabel: false,
      //   },
      //   yAxis: [
      //     {
      //       type: "category",
      //       inverse: true,
      //       axisLine: {
      //         show: false,
      //       },
      //       axisTick: {
      //         show: false,
      //       },
      //       axisLabel: {
      //         interval: 0,
      //         inside: true,
      //         textStyle: {
      //           color: "#fff",
      //           fontSize: 16,
      //         },
      //         show: true,
      //       },
      //       show: false,
      //       data: optionData.yAxis,
      //     },
      //   ],
      //   xAxis: [
      //     {
      //       show: false,
      //     },
      //   ],
      //   series: optionData.series,
      // };

      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} 人({d}%)",
        },
        legend: {
          itemWidth: 14,
          itemHeight: 14,
          orient: "vertical",
          textStyle: {
            fontStyle: "10px",
            color: "#fff",
          },
          top: "15%",
          right: "10%",
          data: (function () {
            let arr = [];
            _this.viewData.UserAgeList.forEach((element) => {
              arr.push(element.age);
            });
            _this.viewData.UserSexList.forEach((element) => {
              arr.push(element.sex);
            });
            return arr;
          })(),
        },
        series: [
          {
            name: "数量及占比",
            type: "pie",
            center: ["25%", "50%"],
            radius: [0, "25%"],
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: (function () {
              let arr = [];
              _this.viewData.UserSexList.forEach((ele) => {
                ele.value = ele.sum;
                ele.name = ele.sex;
                arr.push(ele);
              });
              return arr;
            })(),
          },
          {
            name: "数量及占比",
            type: "pie",
            center: ["25%", "50%"],
            radius: ["40%", "55%"],
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            data: (function () {
              let arr = [];
              _this.viewData.UserAgeList.forEach((ele) => {
                ele.value = ele.sum;
                ele.name = ele.age;
                arr.push(ele);
              });
              return arr;
            })(),
          },
        ],
      };
      sexAndAge.setOption(option);
      window.addEventListener("resize", () => {
        sexAndAge.resize();
      });
    },
    getArrayValue(array, key) {
      var key = key || "value";
      var res = [];
      if (array) {
        array.forEach(function (t) {
          res.push(t[key]);
        });
      }
      return res;
    },
    array2obj(array, key) {
      var resObj = {};
      for (var i = 0; i < array.length; i++) {
        resObj[array[i][key]] = array[i];
      }
      return resObj;
    },
    getData(data) {
      var res = {
        series: [],
        yAxis: [],
      };
      for (let i = 0; i < data.length; i++) {
        // console.log([70 - i * 15 + '%', 67 - i * 15 + '%']);
        res.series.push({
          name: "",
          type: "pie",
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          radius: [73 - i * 15 + "%", 68 - i * 15 + "%"],
          center: ["30%", "55%"],
          label: {
            show: false,
          },
          itemStyle: {
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            borderWidth: 5,
          },
          data: [
            {
              value: data[i].value,
              name: data[i].name,
            },
            {
              value: this.sumValue - data[i].value,
              name: "",
              itemStyle: {
                color: "rgba(0,0,0,0)",
                borderWidth: 0,
              },
              tooltip: {
                show: false,
              },
              hoverAnimation: false,
            },
          ],
        });
        res.series.push({
          name: "",
          type: "pie",
          silent: true,
          z: 1,
          clockWise: false, //顺时加载
          hoverAnimation: false, //鼠标移入变大
          radius: [73 - i * 15 + "%", 68 - i * 15 + "%"],
          center: ["30%", "55%"],
          label: {
            show: false,
          },
          itemStyle: {
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            borderWidth: 5,
          },
          data: [
            {
              value: 7.5,
              itemStyle: {
                color: "rgb(3, 31, 62)",
                borderWidth: 0,
              },
              tooltip: {
                show: false,
              },
              hoverAnimation: false,
            },
            {
              value: 2.5,
              name: "",
              itemStyle: {
                color: "rgba(0,0,0,0)",
                borderWidth: 0,
              },
              tooltip: {
                show: false,
              },
              hoverAnimation: false,
            },
          ],
        });
        res.yAxis.push(
          ((data[i].value / this.sumValue) * 100).toFixed(2) + "%"
        );
      }
      return res;
    },
    // 学历和职称
    xueliInit() {
      let _this = this;
      var xueli = this.$echarts.init(
        document.getElementById("xueli"),
        "macarons"
      );
      // let option = {
      //   tooltip: {
      //     trigger: "item",
      //     formatter: "{a} <br/>{b}: {c} 人({d}%)",
      //   },
      //   legend: {
      //     type: "scroll",
      //     orient: "vertical",
      //     top: "15%",
      //     left: "60%",
      //     itemWidth: 14,
      //     itemHeight: 14,
      //     textStyle: {
      //       fontStyle: "10px",
      //       color: "#fff",
      //     },
      //     data: (function () {
      //       let arr = [];
      //       _this.viewData.UserEduList.forEach((ele) => {
      //         arr.push(ele.edu);
      //       });
      //       _this.viewData.UserRanksList.forEach((ele) => {
      //         arr.push(ele.ranks);
      //       });
      //       return arr;
      //     })(),
      //   },
      //   series: [
      //     {
      //       name: "学历",
      //       type: "pie",
      //       center: ["25%", "50%"],
      //       radius: [0, "25%"],
      //       label: {
      //         show: false,
      //         position: "center",
      //       },
      //       labelLine: {
      //         show: false,
      //       },
      //       data: (function () {
      //         let arr = [];
      //         _this.viewData.UserEduList.forEach((ele) => {
      //           ele.name = ele.edu;
      //           ele.value = ele.sum;
      //           arr.push(ele);
      //         });
      //         return arr;
      //       })(),
      //     },
      //     {
      //       name: "职称",
      //       type: "pie",
      //       center: ["25%", "50%"],
      //       radius: ["40%", "55%"],
      //       label: {
      //         show: false,
      //         position: "center",
      //       },
      //       labelLine: {
      //         show: false,
      //       },
      //       data: (function () {
      //         let arr = [];
      //         _this.viewData.UserRanksList.forEach((ele) => {
      //           ele.name = ele.ranks;
      //           ele.value = ele.sum;
      //           arr.push(ele);
      //         });
      //         return arr;
      //       })(),
      //     },
      //   ],
      // };
      var arrName = getArrayValue(_this.viewData.UserAgeList, "age");
      var arrValue = getArrayValue(_this.viewData.UserAgeList, "sum");
      var sumValue = eval(arrValue.join("+"));
      var objData = array2obj(_this.viewData.UserAgeList, "age");
      var optionData = getData(_this.viewData.UserAgeList);
      this.ageProportion = arrName.map((e, i) => {
        return {
          name: e,
          value: (
            arrValue[i] /
            arrValue.reduce((a, b) => { 
              return (a += b);
            }, 0)
          ).toFixed(2)*100+'%',
        };
      });
      function getArrayValue(array, key) {
        var key = key || "age";
        var res = [];
        if (array) {
          array.forEach(function (t) {
            res.push(t[key]);
          });
        }
        return res;
      }

      function array2obj(array, key) {
        var resObj = {};
        for (var i = 0; i < array.length; i++) {
          resObj[array[i][key]] = array[i];
        }
        return resObj;
      }

      function getData(data) {
        var res = {
          series: [],
          yAxis: [],
        };
        for (let i = 0; i < data.length; i++) {
          // console.log([70 - i * 15 + '%', 67 - i * 15 + '%']);
          res.series.push({
            name: "",
            type: "pie",
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [73 - i * 15 + "%", 68 - i * 15 + "%"],
            center: ["40%", "55%"],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: data[i].sum,
                name: data[i].age,
              },
              {
                value: sumValue - data[i].sum,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.series.push({
            name: "",
            type: "pie",
            silent: true,
            z: 1,
            clockWise: false, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [73 - i * 15 + "%", 68 - i * 15 + "%"],
            center: ["40%", "55%"],
            label: {
              show: false,
            },
            itemStyle: {
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              borderWidth: 5,
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: "rgb(3, 31, 62)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
              {
                value: 2.5,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0,
                },
                tooltip: {
                  show: false,
                },
                hoverAnimation: false,
              },
            ],
          });
          res.yAxis.push(((data[i].value / sumValue) * 100).toFixed(2) + "%");
        }
        return res;
      }

      let option = {
        // backgroundColor: "#000",
        legend: {
          show: false,
          icon: "diamond",
          top: "center",
          left: "70%",
          data: arrName,
          width: 50,
          padding: [0, 5],
          itemGap: 25,
          formatter: function (name) {
            return "{title|" + name + "}\n{value|" + objData[name].sum + "}";
          },

          textStyle: {
            rich: {
              title: {
                // fontSize: 16,
                // lineHeight: 15,
                color: "rgb(0, 178, 246)",
              },
              value: {
                // fontSize: 18,
                // lineHeight: 20,
                color: "#fff",
              },
            },
          },
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{a}<br>{b}:{c}({d}%)",
        },
        color: [
          "rgb(24, 183, 142)",
          "rgb(1, 179, 238)",
          "rgb(22, 75, 205)",
          "rgb(52, 52, 176)",
        ],
        grid: {
          top: "16%",
          bottom: "53%",
          left: "30%",
          containLabel: false,
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              inside: true,
              textStyle: {
                color: "#fff",
                fontSize: 16,
              },
              show: false,
            },
            data: optionData.yAxis,
          },
        ],
        xAxis: [
          {
            show: false,
          },
        ],
        series: optionData.series,
      };

      xueli.setOption(option);
      window.addEventListener("resize", () => {
        xueli.resize();
      });
    },
    // 等次次数
    loginNum() {
      let _this = this;
      var loginNum = this.$echarts.init(
        document.getElementById("loginNum"),
        "macarons"
      );
      let option = {
        // title: {
        //   text: "登录次数统计",
        //   left: "center",
        //   textStyle: {
        //     color: "#fff"
        //   }
        // },
        grid: {
          top: 10,
        },
        xAxis: {
          type: "category",
          axisLine: {
            onZero: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          data: (function () {
            let arr = [];
            _this.viewData.LoginList.forEach((ele) => {
              arr.push(ele.date);
            });
            return arr.reverse();
          })(),
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            left: "9%",
            bottom: -5,
            start: 60,
            textStyle: {
              color: "#fff",
            },
            end: 100, //初始化滚动条
          },
        ],
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#184E80",
            },
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: (function () {
              let arr = [];
              _this.viewData.LoginList.forEach((ele) => {
                arr.push(ele.sum);
              });
              return arr.reverse();
            })(),
            type: "line",
            itemStyle: {
              normal: {
                areaStyle: { type: "default" },
                color: "rgba(17,99,224,0.4)",
              },
            },
            lineStyle: {
              color: "#03ECF2",
            },
            symbol: "none",
            smooth: true,
          },
        ],
        tooltip: {
          trigger: "axis",
          formatter: "{b}: {c} 次",
        },
      };

      loginNum.setOption(option);
      window.addEventListener("resize", () => {
        loginNum.resize();
      });
    },
    // 企业类比情况
    enterpriseAnalogy() {
      let _this = this;
      var enterpriseAnalogy = _this.$echarts.init(
        document.getElementById("enterpriseAnalogy"),
        "macarons"
      );
      let option = {
        // title: {
        //   text: "企业类别情况",
        //   left: "center",
        //   textStyle: {
        //     color: "#fff"
        //   }
        // },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}个 ({d}%)",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          itemWidth: 14,
          itemHeight: 14,
          orient: "vertical",
          textStyle: {
            fontStyle: "10px",
            color: "#fff",
          },
          top: "15%",
          left: "65%",
          data: (function () {
            let arr = [];
            _this.viewData.CompanyTypeList.forEach((ele) => {
              arr.push(ele.type);
            });
            return arr;
          })(),
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: ["35%", "80%"],
            roseType: "radius", //南丁格尔玫瑰图参数
            label: {
              show: false,
              position: "center",
            },
            itemStyle: {
              borderRadius: 5,
            },
            labelLine: {
              show: false,
            },
            center: ["30%", "50%"],
            data: (function () {
              let arr = [];
              _this.viewData.CompanyTypeList.forEach((ele) => {
                arr.push({ value: ele.sum, name: ele.type });
              });
              return arr;
            })(),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      enterpriseAnalogy.setOption(option);
      window.addEventListener("resize", () => {
        enterpriseAnalogy.resize();
      });
    },
    DataList() {
      let _this = this;
      var DataList = _this.$echarts.init(
        document.getElementById("DataList"),
        "macarons"
      );
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          show: true,
        },
        legend: {
          show: false,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "10",
          containLabel: true,
        },
        xAxis: {
          show: false,
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          type: "category",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          data: (function () {
            let arr = [];
            _this.viewData.DataList.forEach((ele) => {
              arr.push(ele.name);
            });
            return arr;
          })(),
        },
        series: [
          {
            name: "数量",
            type: "bar",
            data: (function () {
              let arr = [];
              _this.viewData.DataList.forEach((ele) => {
                arr.push({ value: ele.sum, name: ele.name });
              });
              return arr;
            })(),
            barWidth: 10,
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.1)",
              barBorderRadius: [0, 5, 5, 0],
              borderColor: "rgba(13,111,189,0.1)",
              borderWidth: 1,
            },
            label: {
              show: true,
              offset: [100, 0],
              // distance: 10,
              // align:'right',
              shadowColor: "transparent",
              formatter: "{c}",
            },
            itemStyle: {
              normal: {
                barBorderRadius: [0, 100, 100, 0],
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#203BB6", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#43E6DF", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };

      DataList.setOption(option);
      window.addEventListener("resize", () => {
        DataList.resize();
      });
    },
    ModelSumList() {
      let _this = this;
      var ModelSumList = _this.$echarts.init(
        document.getElementById("ModelSumList"),
        "macarons"
      );
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: "{b}: {c} 个",
        },
        grid: {
          top: 10,
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            xAxisIndex: [0],
            left: "9%",
            bottom: -5,
            start: 60,
            textStyle: {
              color: "#fff",
            },
            end: 100, //初始化滚动条
          },
        ],
        xAxis: {
          type: "category",
          axisLine: {
            onZero: true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          data: (function () {
            let arr = [];
            _this.viewData.ModelSumList.forEach((ele) => {
              arr.push(ele.date);
            });
            return arr;
          })(),
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            onZero: true,
            lineStyle: {
              color: "#3187D5",
            },
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "#184E80",
            },
          },
          axisTick: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: (function () {
              let arr = [];
              _this.viewData.ModelSumList.forEach((ele) => {
                arr.push(ele.sum);
              });
              return arr;
            })(),
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: [100, 100, 0, 0],
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#3BCCF2", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#1F8EF0", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(220, 220, 220, 0.1)",
              barBorderRadius: [5, 5, 0, 0],
              borderColor: "rgba(13,111,189,0.7)",
              borderWidth: 1,
            },
          },
        ],
      };

      ModelSumList.setOption(option);
      window.addEventListener("resize", () => {
        ModelSumList.resize();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dataView {
  width: 100%;
  height: 100%;
  color: #333;
  /* overflow: hidden; */
  background-size: 100% 100%;
  // background-color: #22223b;
  background-image: url("../../assets/admin/dataImg/bg.png");
  overflow: auto;
}
.t_title {
  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 2.5rem;
  /* line-height: 80px; */
  color: #fff;
}

/*header开始*/
.header {
  width: 100%;
  height: 8%;
}
.bg_header {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
}

.data_content {
  height: 90%;
}

.data_content .data_main {
  width: calc(100% - 40px);
  height: 100%;
  margin-left: 20px;
}
.data_content .data_main .data_main_top {
  width: 100%;
  height: 15%;
  padding-bottom: 10px;
  color: #fff;
}
// 上方title
.data_content .data_main .data_main_top .main_top1 {
  width: 20%;
  height: 100%;
  text-align: center;
  cursor: pointer;
}
.data_content .data_main .data_main_top .main_top1 .mainbg1 {
  width: 100%;
  background: url("../../assets/admin/dataImg/Group 148.png") no-repeat 25% 50%;
}
.data_content .data_main .data_main_top .main_top1 .mainbg2 {
  background: url("../../assets/admin/dataImg/2.png") no-repeat 25% 50%;
}
.data_content .data_main .data_main_top .main_top1 .mainbg3 {
  background: url("../../assets/admin/dataImg/3.png") no-repeat 25% 50%;
}
.data_content .data_main .data_main_top .main_top1 .mainbg4 {
  background: url("../../assets/admin/dataImg/4.png") no-repeat 25% 50%;
}
.data_content .data_main .data_main_top .main_top1 .mainbg5 {
  background: url("../../assets/admin/dataImg/5.png") no-repeat 25% 50%;
}
.data_content .data_main .main_left {
  width: 24%;
  // height: 100%;
  height: 85%;
  background: rgba(5, 57, 154, 0.3);
}
.data_content .data_main .main_left > div {
  width: 100%;
  height: 30%;
  // box-sizing: border-box;
  // border: 1px solid #2c58a6;
  // position: relative;
  // box-shadow: 0 0 10px #2c58a6;
}

.data_content .data_main .main_left div.left_2 {
  // margin-top: 4.22vh;
  margin-top: 3.22vh;
  height: 35% !important;
}
.data_content .data_main .main_left div .main_title {
  width: 180px;
  height: 35px;
  line-height: 33px;
  background-color: #2c58a6;
  border-radius: 18px;
  position: absolute;
  top: -17px;
  left: 50%;
  margin-left: -90px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  box-sizing: border-box;
  /* padding-left: 45px; */
  text-align: center;
  z-index: 1000;
}
.data_content .data_main .main_left div .main_title1 {
  width: 85%;
  height: 40px;
  line-height: 40px;
  padding-left: 15%;
  color: #fff;
  text-shadow: 1px 3px 3px #fff;
  border-bottom: 1px solid #033d52;
  background: url("../../assets/admin/dataImg/标题栏.png") no-repeat 5%;
}
.data_content .data_main .main_center {
  width: 52%;
  // height: 99.3%;
  height: 85.3%;
}
.data_content .data_main .main_center .center_text {
  width: calc(100% - 50px);
  height: 100%;
  margin-left: 25px;
  margin-right: 25px;
  // box-sizing: border-box;
  // border: 1px solid #2c58a6;
  // box-shadow: 0px 0px 6px #2c58a6;
  position: relative;
}
.l_t_line {
  width: 5px;
  height: 24px;
  left: -3px;
  top: -3px;
}
.t_l_line {
  height: 5px;
  width: 26px;
  left: -3px;
  top: -3px;
}
.t_line_box {
  position: absolute;
  width: 100%;
  height: 100%;
}
.t_line_box i {
  background-color: #4788fb;
  box-shadow: 0px 0px 10px #4788fb;
  position: absolute;
}
.t_r_line {
  height: 5px;
  width: 26px;
  right: -3px;
  top: -3px;
}
.r_t_line {
  width: 5px;
  height: 24px;
  right: -3px;
  top: -3px;
}
.l_b_line {
  width: 5px;
  height: 24px;
  left: -3px;
  bottom: -3px;
}
.b_l_line {
  height: 5px;
  width: 26px;
  left: -3px;
  bottom: -3px;
}
.r_b_line {
  width: 5px;
  height: 24px;
  right: -3px;
  bottom: -3px;
}
.b_r_line {
  height: 5px;
  width: 26px;
  right: -3px;
  bottom: -3px;
}
.data_content .data_main .main_center .main_title {
  width: 180px;
  height: 35px;
  line-height: 33px;
  background-color: #2c58a6;
  border-radius: 18px;
  position: absolute;
  top: -17px;
  left: 50%;
  margin-left: -90px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  box-sizing: border-box;
  /* padding-left: 45px; */
  text-align: center;
  z-index: 1000;
}

.data_content .data_main .main_right {
  width: 24%;
  // height: 100%;
  height: 85%;
  background: rgba(5, 57, 154, 0.3);
}
.data_content .data_main .main_right > div {
  width: 100%;
  height: 30%;
  // box-sizing: border-box;
  // border: 1px solid #2c58a6;
  // position: relative;
  // box-shadow: 0 0 10px #2c58a6;
}
.data_content .data_main .main_right div.right_2 {
  // margin-top: 4.22vh;
  margin-top: 3.22vh;
}

.data_content .data_main .main_right div .main_title {
  width: 180px;
  height: 35px;
  line-height: 33px;
  background-color: #2c58a6;
  border-radius: 18px;
  position: absolute;
  top: -17px;
  left: 50%;
  margin-left: -90px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  box-sizing: border-box;
  /* padding-left: 45px; */
  text-align: center;
}
.data_content .data_main .main_right div .main_title img {
  position: absolute;
  top: 8px;
  left: 20px;
}

.data_content .data_main .main_right div .main_title1 {
  width: 85%;
  height: 40px;
  line-height: 40px;
  padding-left: 15%;
  color: #fff;
  text-shadow: 1px 3px 3px #fff;
  border-bottom: 1px solid #033d52;
  background: url("../../assets/admin/dataImg/标题栏.png") no-repeat 5%;
}
.lineStyle_1 {
  height: 1px;
  background-color: #03bdd5;
  width: 90%;
  margin: 0 auto;
  position: relative;
  // top: 50%;
  margin-top: -0.5px;
}
.lineStyle_2 {
  width: 90%;
  margin: 0 auto;
  top: -6px;
  padding: 0 5%;
  position: relative;
  border: 1px dashed #03bdd5;
}
.lineStyle_3 {
  width: 30px;
  float: right;
  height: 1px;
  background-color: #03bdd5;
  // left: 62px;
  left: 62px;
  top: -3px;
  position: relative;
}
.lineStyle_3::after {
  content: "";
  position: absolute;
  width: 30px;
  height: 1px;
  left: 24px;
  top: -10px;
  bottom: 0;
  background-color: #03bdd5;
  transform: rotate(-45deg);
}
.lineStyle_3::before {
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  left: 48px;
  top: -28px;
  bottom: 0;
  border: 1px solid #03bdd5;
}
.lineStyle_1::before {
  content: "";
  left: -25px;
  position: absolute;
  top: -2px;
  width: 20px;
  height: 4px;
  background-color: #03bdd5;
}
.lineStyle_1::after {
  content: "";
  right: -25px;
  position: absolute;
  top: -2px;
  width: 20px;
  height: 4px;
  background-color: #03bdd5;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.t_btn6 {
  height: 20% !important;
}

.myNav {
  width: 80%;
  height: 10vh;
  position: absolute;
  top: 5%;
  left: 25%;
  .mybtn {
    width: 70px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border-radius: 5px;
    background: brown;
    box-shadow: 0px 0px 5px #fff;
    float: left;
    margin-right: 20px;
    cursor: pointer;
  }
  .mybtn:hover {
    animation: btn 2s;
  }
  @keyframes btn {
    100% {
      width: 80px;
      height: 35px;
      line-height: 35px;
      font-size: 15px;
      box-shadow: 0px 0px 8px #fff;
    }
  }
}
/* 新增 */
.width-he100 {
  width: 100%;
  // height: 100%;
  height: 80%;
}
.flex_center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.fontS28 {
  font-size: 28px;
  font-style: oblique;
}
.colorGray {
  color: #818388;
}
.active {
  background: url("../../assets/admin/dataImg/选中.png") no-repeat 60%;
}
.xueName {
  width: 90%;
  height: 30px;
  line-height: 30px;
  background: url("../../assets/admin/dataImg/Group 173-2.png") no-repeat;
  background-size: 100% 100%;
}
.xueName:nth-child(2) {
  background: url("../../assets/admin/dataImg/Group 173-3.png") no-repeat;
  background-size: 100% 100%;
}
.xueName:nth-child(3) {
  background: url("../../assets/admin/dataImg/Group 173.png") no-repeat;
  background-size: 100% 100%;
}
.xueName:nth-child(4) {
  background: url("../../assets/admin/dataImg/Group 173-1.png") no-repeat;
  background-size: 100% 100%;
}
.xueName > div:last-child {
  color: #1a73d3;
}
.xueName:nth-child(2) > div:last-child {
  color: #0ab77d;
}
.xueName:nth-child(3) > div:last-child {
  color: #28aadf;
}
.xueName:nth-child(4) > div:last-child {
  color: #0b9cb1;
}
</style>
